import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import PlaybookTemplatesQuery$parameters from '@atlassian/jira-playbooks-list-screen/src/ui/playbook-templates/__generated__/PlaybookTemplatesQuery$parameters';

const playbookTemplatesEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-playbook-templates" */ './src'),
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => {
		const { projectKey } = context.match.params;
		const { name = '' } = context.query;

		if (!projectKey) {
			throw new Error('projectKey is required');
		}

		return {
			queries: {
				PlaybookTemplatesQuery: {
					parameters: PlaybookTemplatesQuery$parameters,
					variables: {
						cloudId: tenantContext.cloudId,
						projectKey,
						filters: name ? { name } : null,
					},
				},
			},
			extraProps: {
				projectKey: context.match.params.projectKey,
			},
		};
	},
});

export default playbookTemplatesEntryPoint;
